import React, { useId } from 'react';
import { cn } from 'lib/utils';
import { FieldLabel, Select, type SelectProps } from 'ui';

export type SelectFieldProps = SelectProps & {
  className?: string;
  isRequired?: boolean;
  label: string;
};

const SelectField = ({
  className,
  id: propId,
  isRequired,
  label,
  ...props
}: SelectFieldProps) => {
  const dynamicId = useId();
  const id = propId ?? dynamicId;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <FieldLabel htmlFor={id} {...{ isRequired, label }} />
      <Select {...props} {...{ id }} />
    </div>
  );
};

export default SelectField;
